import React, { memo, useEffect, useState } from "react";
import "../css/loader.css";
import logo from "../image/logo.webp";

const Loader = memo(({ fading }) => {
  const [text, setText] = useState("");
  const fullText = "Crafting your resume...";

  // Typewriter effect
  useEffect(() => {
    let i = 0;
    const timer = setInterval(() => {
      setText(fullText.slice(0, i + 1));
      i++;
      if (i === fullText.length) clearInterval(timer);
    }, 80);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`resume-loader ${fading ? "fade-out" : ""}`}>
      {/* Animated background gradient */}
      <div className="loader-bg" />

      {/* Brand Logo */}
      <img
        src={logo}
        alt="ResumeEra"
        className="loader-logo"
        loading="eager"
        decoding="async"
        width="120"
        height="120"
      />

      {/* Resume Document Icon (CSS) */}
      <div className="resume-icon">
        <div className="resume-lines">
          <span className="line line1" />
          <span className="line line2" />
          <span className="line line3" />
          <span className="line line4" />
        </div>
      </div>

      {/* Typewriter Text */}
      <p className="loader-text">{text}</p>

      {/* Animated progress bar */}
      <div className="progress-track">
        <div className="progress-bar" />
      </div>
    </div>
  );
});

Loader.displayName = "Loader";
export default Loader;